import { IntlMessageFormat } from "intl-messageformat";

// The assignment is the only wording that is formatted: the title is a plain
// label, CHECK-bound against braces, so it never reaches a formatter.
type QuestAssignmentInput = {
  assignmentTemplate: string | null;
  locale: string | null;
  targetValue: string | null;
  requiredDays: number | null;
};

// The placeholder set is closed: {target} and {days}. Which are legal follows
// from goal_type, but a listing renders whatever the author wrote.
const buildValues = ({ targetValue, requiredDays }: QuestAssignmentInput) => ({
  // numeric(12,3) arrives as "10000.000"; ICU needs the number so that `#`
  // formats it and picks the right plural category.
  ...(targetValue === null ? {} : { target: Number(targetValue) }),
  ...(requiredDays === null ? {} : { days: requiredDays }),
});

export const formatQuestAssignment = (
  input: QuestAssignmentInput,
): string | null => {
  if (input.assignmentTemplate === null) {
    return null;
  }

  try {
    const message = new IntlMessageFormat(
      input.assignmentTemplate,
      input.locale ?? undefined,
    );

    return String(message.format(buildValues(input)));
  } catch {
    // A malformed pattern or a placeholder the quest cannot bind is an
    // authoring defect; show the raw template so it is visible here.
    return input.assignmentTemplate;
  }
};
